/**
 * Admin(L_ADM_USERS) 세션과 일반 사용자 세션 구분.
 * 로컬에서 adm(4000)·user(3000)가 같은 lettaga.sid 를 공유하면
 * /auth/me 는 성공하지만 clientCd 구조가 달라 billing 등에서 401 → 로그인 루프가 난다.
 */

/** 어드민 전용 세션이면 true (사용자 앱에서는 미로그인으로 취급) */
export function isAdminOnlySession(userOrAuth: any): boolean {
  if (!userOrAuth || typeof userOrAuth !== 'object') return false;
  const user =
    userOrAuth.user
    ?? userOrAuth.data?.user
    ?? userOrAuth;
  if (!user || typeof user !== 'object') return false;
  if (user.isAdmin === true) return true;
  // adm-auth 가 session.user 에 넣는 플래그 (중첩 없이 최상위)
  if ((userOrAuth as any).isAdmin === true) return true;
  return false;
}

/** 사용자 앱에서 유효한 로그인으로 볼지 */
export function isValidUserAppAuth(authData: any): boolean {
  if (!authData) return false;
  const ok = authData.success === true && !!(authData.user || authData.data?.user);
  if (!ok) return false;
  return !isAdminOnlySession(authData);
}
